import React, { useEffect, useCallback } from 'react';
import styles from 'assets/css/Requirement.module.css';
import buttonStyles from 'assets/css/Button.module.css';
import CardLink from 'Components/Card/CardLink';
import { IconCPRAED, IconAngleRight, IconCautionTriangle, IconCheckmarkCircle } from '@ace/react-icons';
import { format, } from 'date-fns';
import useAttention from 'context/AttentionContext';
import { getUTCDateFromServerDate } from 'utils/dateUtils';

function RequirementsCard(props) {
    //local var(s)
    const { Requirements: requirements }  = props.data;

    //render
    return (
        <div className={styles.cardBodyDefault}>
            <div className="requirements-container">
                {requirements.map(requirement => (<Requirement requirement={requirement} />))}
            </div>
        </div>
    )
}

const REQUIREMENT_STATE = {
    ACTIVE: "Active",
    AUDIT: "Audit",
    MISSING: "Missing",
    EXPIRED: "Expired"
};

function Requirement({requirement}) {
    const { setAttentionWarning, clearAttentionState } = useAttention();

    useEffect(() => {
        switch (requirement.State) {
            case REQUIREMENT_STATE.AUDIT:
            case REQUIREMENT_STATE.MISSING:
            case REQUIREMENT_STATE.EXPIRED:
                setAttentionWarning();
                break;
            case REQUIREMENT_STATE.ACTIVE:
            default:
                clearAttentionState();
                break;
        }

    }, [setAttentionWarning, clearAttentionState, requirement.State]);


    const StatusSubHeader = useCallback(({icon, state, text}) => {
        return (
            <span className={`${styles.status} ${styles["status" + state]}`}>
                {icon} {text ? text : state}
            </span>
        );
    }, []);

    const Status = useCallback(({state, expirationDate}) => {
        switch (state) {
            case REQUIREMENT_STATE.ACTIVE:
                return (
                    <>
                        <StatusSubHeader icon={<IconCheckmarkCircle />} state={state} />
                        <p className={styles.expiration}>Expires {format(getUTCDateFromServerDate(expirationDate), "MMMM dd, yyyy")}</p>
                    </>
                );
            case REQUIREMENT_STATE.AUDIT:
                return (
                    <StatusSubHeader icon={<IconCautionTriangle />} state={state} text={
                        <div>Audit in progress<span style={{textTransform: "none", display: "block"}}>You will receive an email with instructions to submit your proof of certification.</span></div> } />
                );
            case REQUIREMENT_STATE.MISSING:
            case REQUIREMENT_STATE.EXPIRED:
                return (
                    <StatusSubHeader icon={<IconCautionTriangle />} state={state} />
                );
            default:
                return false;
        }
    }, []);

    const ActionableLink = useCallback(({state, cardLinkUri}) => {
        let linkText = "CPR Info";
        if (state === (REQUIREMENT_STATE.ACTIVE || REQUIREMENT_STATE.AUDIT)) {
            linkText = "Update " + linkText;
        } else {
            linkText = "Add " + linkText;
        }

        return (
            <CardLink linkText={linkText} linkIcon={<IconAngleRight />} linkUrl={cardLinkUri} target="_blank" className={`${buttonStyles.stroke}`} />
        );
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.imgWrap}>
                <IconCPRAED />
            </div>

            <div className={styles.contentWrap}>
                <h4 className={styles.header}>
                    <span>{requirement.HeaderText}</span>
                </h4>
                <Status state={requirement.State} expirationDate={requirement.ExpirationDate} />
                <CardLink
                    linkText={requirement.CPRFaqsLink.CardLinkText}
                    linkIcon={<IconAngleRight />}
                    linkUrl={requirement.CPRFaqsLink.CardLinkUri} target="_blank"
                    className={`${buttonStyles.floating} ${styles.faqLink}`} />
                <ActionableLink state={requirement.State} cardLinkUri={requirement.ActionLink.CardLinkUri} />
            </div>
        </div>
    )
}

export default RequirementsCard;
